import { FileHelper } from '@getaccept/lib-shared/src/file/helpers/file.helper';

export class IconHelper {
  static getFileIcon(fileName: string): string {
    const pdfIconExtensions: string[] = ['.pdf'];
    const docIconExtensions: string[] = ['.doc', '.docx'];
    const pptIconExtensions: string[] = ['.ppt', '.pptx'];
    const imgIconExtensions: string[] = [
      '.jpg',
      '.jpeg',
      '.png',
      '.eps',
      '.gif',
      '.psd',
      '.ai',
      '.svg',
      '.tif',
      '.tiff',
    ];
    const xlsIconExtensions: string[] = ['.xls', '.xlsx'];
    const txtIconExtensions: string[] = ['.txt'];

    const extension: string = FileHelper.extractFileType(fileName);

    switch (true) {
      case pdfIconExtensions.includes(extension):
        return 'file-pdf';
      case docIconExtensions.includes(extension):
        return 'file-doc';
      case pptIconExtensions.includes(extension):
        return 'file-ppt';
      case imgIconExtensions.includes(extension):
        return 'image-placeholder';
      case xlsIconExtensions.includes(extension):
        return 'file-xls';
      case txtIconExtensions.includes(extension):
        return 'file-txt';
      default:
        return 'file-blank';
    }
  }
}
